
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { colors, hexToRGBA } from '../colors.js';

var table = {
  borderBottomColor: colors.secondary.base,
  rowBackgroundColor: colors.secondary.lighter,
  rowHoverColor: hexToRGBA(colors.primary.lightest, 0.25)
};

export { table as default };
//# sourceMappingURL=table.js.map
